import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import _ from 'lodash'

import { ScoringChart } from 'gnos-charts'

import ToggleButton from '../../../../../../../../../../components/ToggleButton'

import Table from './components/DataTable'

import { LOCALE_PREFIX } from '../../../Blocks/BisnodeScoring/constants'

import hocConnect from './hocConnect'
import './style.scss'

@injectIntl
@hocConnect
export default class Chart extends Component {
    static propTypes = {
        bisnodeScoringChartToggleDataTable: PropTypes.func.isRequired,
        block: PropTypes.string.isRequired,
        chartDataTableActive: PropTypes.bool,
        data: PropTypes.array,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        module: PropTypes.string.isRequired,
        originalData: PropTypes.array,
        customData: PropTypes.object,
    }

    onToggleDataTable = () => {
        const { chartDataTableActive, bisnodeScoringChartToggleDataTable, module, block, id, customData } = this.props

        bisnodeScoringChartToggleDataTable(module, id, block, {
            ...customData,
            chartDataTableActive: !chartDataTableActive,
        })
    }

    render() {
        const { data, originalData, intl, chartDataTableActive, id } = this.props

        if (_.isEmpty(data)) return null

        return (
            <div className={'scoring-chart-wrapper'}>
                <div className={'chart-header'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.dataTable`} />
                    <div className={'toggle-btn-container'}>
                        <ToggleButton
                            active={chartDataTableActive || false}
                            inactiveGreyBackground
                            onClickHandler={this.onToggleDataTable}
                            textOff={intl.formatMessage({ id: `${LOCALE_PREFIX}.no` })}
                            textOn={intl.formatMessage({ id: `${LOCALE_PREFIX}.yes` })}
                        />
                    </div>
                </div>
                <div className={'chart-container'}>
                    <ScoringChart
                        key={`bisnode-scoring-chart-${id}`}
                        dataProvider={data}
                        dateFormat={'DD-MM-YYYY'}
                        categoryField={'startDate'}
                        showLegend
                        graphs={[
                            {
                                id: `g1-scoring-${id}`,
                                title: intl.formatMessage({ id: `${LOCALE_PREFIX}.declineProbability` }),
                                dataSelector: 'probability',
                                type: 'line',
                                lineColor: '#29ABE2',
                                lineThickness: 1,
                                fillAlphas: 0,
                                negativeLineColor: '#29ABE2',
                                negativeFillAlphas: 0,
                                balloonColor: '#29ABE2',
                                balloonTextColor: '#ffffff',
                                balloonBorderThickness: 0,
                                balloonTexts: [
                                    {
                                        label: intl.formatMessage({ id: `${LOCALE_PREFIX}.balloon.scoring` }),
                                        dataSelector: 'ratingText',
                                        postfix: intl.formatMessage({ id: `${LOCALE_PREFIX}.balloon.scoringPostfix` }),
                                    },
                                    {
                                        label: intl.formatMessage({ id: `${LOCALE_PREFIX}.balloon.decline` }),
                                        dataSelector: 'probability',
                                        postfix: '%',
                                    },
                                    {
                                        label: intl.formatMessage({ id: `${LOCALE_PREFIX}.balloon.transactionLimit` }),
                                        dataSelector: 'minTransactionLimit',
                                        secondDataSelector: 'maxTransactionLimit',
                                        dataRange: true,
                                        postfix: ` ${intl.formatMessage({
                                            id: `global.currency.${
                                                data.find((val) => !!val.currency)?.currency || 'CZK'
                                            }`,
                                        })}`,
                                    },
                                    {
                                        label: intl.formatMessage({ id: `${LOCALE_PREFIX}.balloon.creditLimit` }),
                                        dataSelector: 'minCreditLimit',
                                        secondDataSelector: 'maxCreditLimit',
                                        dataRange: true,
                                        postfix: ` ${intl.formatMessage({
                                            id: `global.currency.${
                                                data.find((val) => !!val.currency)?.currency || 'CZK'
                                            }`,
                                        })}`,
                                    },
                                ],
                            },
                        ]}
                        style={{ height: '500px', width: '100%', marginBottom: '-14px' }}
                        monthNames={[
                            intl.formatMessage({ id: 'global.january' }),
                            intl.formatMessage({ id: 'global.february' }),
                            intl.formatMessage({ id: 'global.march' }),
                            intl.formatMessage({ id: 'global.april' }),
                            intl.formatMessage({ id: 'global.may' }),
                            intl.formatMessage({ id: 'global.june' }),
                            intl.formatMessage({ id: 'global.july' }),
                            intl.formatMessage({ id: 'global.august' }),
                            intl.formatMessage({ id: 'global.september' }),
                            intl.formatMessage({ id: 'global.october' }),
                            intl.formatMessage({ id: 'global.november' }),
                            intl.formatMessage({ id: 'global.december' }),
                        ]}
                    />
                </div>
                {chartDataTableActive && (
                    <div className={'table-container'}>
                        <Table id={id} data={originalData?.[1]?.scoringProbabilities || []} />
                    </div>
                )}
            </div>
        )
    }
}
